// Taşeron portalı — pano paneli kabuğu + başlığı (S37-3, design review M2). web-expert'in
// `components/PanelHeader.tsx` + panel kabuğunun (`DashboardPage.tsx:357-395`) YEREL yeniden
// kurulumu (app sınırı: import değil, kopya): `rounded-sm border bg-surface shadow-sm` panel,
// başlık = `border-b px-4 py-3` + `min-h-9` satır + `text-primary` ikon + h2. Kabuk bilinçli
// olarak Tile (`Card`) DEĞİL — S37-7 `shadow-sm` taramasının izin listesi bu panellerdir.

import { cn } from '@isgportal/shared';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

/** Panel dış kabuğu — `@container`: içindeki sütun açılımı (UpcomingPermitsCard) viewport'a
 *  değil PANELİN genişliğine bağlıdır (2+1 grid'de panel genişliği viewport'tan bağımsız değişir). */
export function DashboardPanel({
  className,
  children,
}: { className?: string; children: ReactNode }) {
  return (
    <div
      className={cn(
        '@container flex flex-col rounded-sm border border-border bg-surface shadow-sm',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function PanelHeader({
  icon: Icon,
  title,
  right,
}: {
  icon: LucideIcon;
  title: string;
  right?: ReactNode;
}) {
  return (
    <div className="border-b border-border px-4 py-3">
      <div className="flex min-h-9 flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-1.5">
          <Icon className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
          <h2 className="text-base font-semibold text-fg">{title}</h2>
        </div>
        {right}
      </div>
    </div>
  );
}
